import { JOBS_STATUS } from 'models';

export const CAN_NOT_CANCEL = [
  JOBS_STATUS.STARTED,
  JOBS_STATUS.EXPIRED,
  JOBS_STATUS.COMPLETED,
  JOBS_STATUS.CANCELED,
  JOBS_STATUS.PENDING_COMPLETION,
];

export const CAN_NOT_MARK_AS_COMPLETED = [
  JOBS_STATUS.EXPIRED,
  JOBS_STATUS.COMPLETED,
  JOBS_STATUS.CANCELED,
  JOBS_STATUS.PENDING,
];
